import React from 'react';
import Hero from './Hero.js';
import About from './About.js';
import Skills from './Skills.js';
import Projects from './Projects.js';
import Contact from './Contact.js';
import Footer from './Footer.js';
import Navigation from './Navigation.js';
import GreetingOverlay from './GreetingOverlay.js';
import './Portfolio.css';

const Portfolio = () => {
  return (
    <div className="portfolio-container">
      {/* During development this forces the greeting to appear on every load. Remove `forceShow` when ready. */}
      <GreetingOverlay forceShow={true} />
      <Navigation />
      <Hero />
      <About />
      <Skills />
      <Projects />
      <Contact />
      <Footer />
    </div>
  );
};

export default Portfolio;